import { apiV3Client } from './BaseRepository';

export function fetchMergeTags() {
  return apiV3Client.get(`MergeTags`);
}
